import { jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { Box } from "../Box/Box.mjs";
import { Toast } from "./Toast.mjs";
import { useFlipList } from "./useFlipList.mjs";
const Toaster = ({ toasts, removeToast }) => {
  const { itemRef, remove } = useFlipList();
  const onClose = useCallback(
    (dedupeKey, toastKey) => {
      remove(toastKey, () => {
        removeToast(dedupeKey);
      });
    },
    [remove, removeToast]
  );
  return /* @__PURE__ */ jsx(
    Box,
    {
      position: "fixed",
      zIndex: "notification",
      width: "full",
      pointerEvents: "none",
      paddingX: "gutter",
      bottom: 0,
      children: toasts.map(({ toastKey, ...rest }) => /* @__PURE__ */ jsx(Box, { paddingBottom: "small", children: /* @__PURE__ */ jsx(
        Toast,
        {
          ref: itemRef(toastKey),
          toastKey,
          onClose,
          ...rest
        }
      ) }, toastKey))
    }
  );
};
export {
  Toaster
};
